export default [
  {
    path: '/clients',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "clients-list" */ '@/views/clients/List.vue'),
  }, {
    path: '/clients/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "clients-create" */ '@/views/clients/Create.vue'),
  }, {
    path: '/clients/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "clients-page" */ '@/views/clients/Client.vue'),
  }
]
